import React, { useRef } from "react";
import Hero from "./Hero";
import FAQs from "./FAQs";
import Footer from "./Footer";
import Contact from "./Contact";
import Pricing from "./Pricing";
import Newsletter from "./Newsletter";
import Clients from "./Clients";
import AboutUs from "./AboutUs";
import Services from "./Services";
import Features from "./Features";
import LaunchingSoon from "./LaunchingSoon";
import Header from "./Header";
import Marque from "./Marque";
import Testimonial from "./Testimonial";

const Home = () => {
  const mainRef = useRef(null);
  const aboutRef = useRef(null);
  const servicesRef = useRef(null);
  const featuresRef = useRef(null);
  const pricingRef = useRef(null);
  const contactRef = useRef(null);
  return (
    <div>
      <div className="sticky">
        <Marque />
      </div>
      <div className="sticky-padding mt-3">
        <Hero
          mainRef={mainRef}
          aboutRef={aboutRef}
          servicesRef={servicesRef}
          featuresRef={featuresRef}
          pricingRef={pricingRef}
          contactRef={contactRef}
        />
        <AboutUs aboutRef={aboutRef} />
        {/* <LaunchingSoon /> */}
        <Services servicesRef={servicesRef} />
        <Features featuresRef={featuresRef} />
        {/* <Testimonial /> */}
        {/* <LaunchingSoon /> */}
        {/* <Clients /> */}
        {/* <Pricing pricingRef={pricingRef} /> */}
        <FAQs />
        {/* <LaunchingSoon /> */}
        <Contact contactRef={contactRef} />
        <Newsletter />
        <Footer
          mainRef={mainRef}
          aboutRef={aboutRef}
          servicesRef={servicesRef}
          featuresRef={featuresRef}
          pricingRef={pricingRef}
          contactRef={contactRef}
        />
      </div>
    </div>
  );
};

export default Home;
